import { Component } from 'react'
import * as styles from 'components/features/socialFeed/SocialProfileConfirmation/SocialProfileConfirmation.styl'
import SocialProfileInfoContainer from 'components/features/socialFeed/SocialProfileInfo/SocialProfileInfoContainer'
import { PeergroupDefinition } from 'interfaces/peergroups'
import { preparePeerDefinitionProps } from 'helpers/peergroupsHelpers'
import { PeerDefinition } from 'components/features/pfm/PeerDefinition/PeerDefinition'

export type SocialProfileConfirmationStateProps = {
  peergroup: PeergroupDefinition
}

type SocialProfileConfirmationProps =
  & SocialProfileConfirmationStateProps

class SocialProfileConfirmation extends Component<SocialProfileConfirmationProps> {
  render () {
    const { peergroup } = this.props

    return (
      <div className={ styles.socialProfileConfirmation }>
        <SocialProfileInfoContainer readonly />
        <div className={ styles.separator } />
        <div className={ styles.definitionWrapper }>
          <PeerDefinition
            isRange
            { ...preparePeerDefinitionProps(peergroup) }
          />
        </div>
      </div>
    )
  }
}

export default SocialProfileConfirmation
